/**
 * Boutique of Pashtuns — collection page grid/list view toggle.
 *
 * A single document-level delegated listener (same pattern as
 * pashtuns-gallery-nav.js) instead of a custom element -- there's no
 * per-instance state to track beyond the DOM itself, and delegation means
 * this keeps working after Shopify Theme Editor swaps the section's DOM
 * on a settings change, with no re-init step required.
 *
 * Reuses Dawn's own .card--horizontal styling (already used elsewhere in
 * the theme) for list view instead of building a separate layout, and
 * only ever toggles classes -- no re-fetch, no re-render, so it works
 * instantly on the products already in the DOM.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('.pashtuns-view-toggle__button');
  if (!button) return;

  const toggle = button.closest('.pashtuns-view-toggle');
  const grid = document.getElementById('product-grid');
  if (!toggle || !grid) return;

  toggle.querySelectorAll('.pashtuns-view-toggle__button').forEach((btn) => {
    btn.classList.remove('is-active');
    btn.setAttribute('aria-pressed', 'false');
  });
  button.classList.add('is-active');
  button.setAttribute('aria-pressed', 'true');

  grid.classList.remove('pashtuns-product-grid--small', 'pashtuns-product-grid--list');
  grid.querySelectorAll('.card').forEach((card) => card.classList.remove('card--horizontal'));

  const view = button.dataset.view;
  if (view === 'grid-small') {
    grid.classList.add('pashtuns-product-grid--small');
  } else if (view === 'list') {
    grid.classList.add('pashtuns-product-grid--list');
    grid.querySelectorAll('.card').forEach((card) => card.classList.add('card--horizontal'));
  }
});
